import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularSend: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_send"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="send icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M16.0063 3.5C15.5047 3.49997 15.0981 3.90762 15.0981 4.41052C15.0981 4.91341 15.5046 5.32111 16.0062 5.32114L17.3991 5.32122L9.30467 13.4362C8.94999 13.7918 8.94996 14.3683 9.30459 14.7239C9.65922 15.0795 10.2342 15.0796 10.5889 14.724L18.6836 6.60873L18.6837 7.99807C18.6837 8.50096 19.0904 8.90861 19.5919 8.90857C20.0935 8.90854 20.5 8.50083 20.5 7.99794L20.4997 4.41071C20.4997 3.90787 20.0932 3.50024 19.5917 3.50021L16.0063 3.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.22554 15.0385C4.71836 15.0385 3.5 16.263 3.5 17.7692C3.5 19.2755 4.71836 20.5 6.22554 20.5C7.73272 20.5 8.95108 19.2755 8.95108 17.7692C8.95108 16.263 7.73272 15.0385 6.22554 15.0385ZM5.31832 17.7692C5.31832 17.2638 5.7264 16.8576 6.22554 16.8576C6.72468 16.8576 7.13276 17.2638 7.13276 17.7692C7.13276 18.2746 6.72468 18.6809 6.22554 18.6809C5.7264 18.6809 5.31832 18.2746 5.31832 17.7692Z"
        />
      </svg>
    </span>
  );
};

export { RegularSend };
